angular
    .module('kareo.ui.shared.modules.api.practice-timezone-service', [])
    .factory('practiceTimeZoneService', ['$http', '$q',
      function practiceTimeZoneService($http, $q) {
        var getTimeZoneURL = '/common-ui/api/Practice/timezone';
        return {
          getPracticeTimeZone() {
            return $http.get(getTimeZoneURL, { cache: true }).then((response) => {
              return response.data;
            }, (response) => {
              return $q.reject(response.data);
            });
          }
        };
      }]);
